import { api } from "./base";
/**
 * Реферальные данные текущего пользователя (auth allow_guest, cookie).
 * Возвращает реф-код, готовую ссылку на сайт и счётчики приглашений/покупок/бонусов.
 */
export const getMyReferral = async () => {
    const response = await api.get("/api/v1/public/users/me/referral", {
        withCredentials: true,
    });
    return response.data;
};
